<template>
  <div
    class="rn-back-top"
    :class="[visible ? 'd-inline' : 'd-none']"
    @click="scrollToTop"
  >
    <Icon
      name="chevron-up"
      size="27"
    />
  </div>
</template>

<script>
    import Icon from '../../icon/Icon'

    export default {
        name: 'ScrollTop',
        components: {Icon},
        data() {
            return {
                visible: false
            }
        },
        created() {
            window.addEventListener('scroll', this.toggleVisible);
        },
        mounted() {
            this.toggleVisible();
        },
        beforeUnmount() {
            window.removeEventListener('scroll', this.toggleVisible);
        },
        methods: {
            scrollToTop() {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            },
            toggleVisible() {
                const scrolled = document.documentElement.scrollTop;
                if (scrolled > 300) {
                    this.visible = true;
                } else if (scrolled <= 300) {
                    this.visible = false;
                }
            }
        }
    }
</script>